import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="aboutus">
      <h4>Version 1.0.0</h4>
      <Link to="/">Go back</Link>
    </div>
  );
};

export default About;
